// extracted by mini-css-extract-plugin
export default {"container":"Mo-z","ratingLayout":"No-z","ratingLabel":"Oo-z","nonInteractiveRatingLabel":"Po-z"};